import React from "react";
import { Link } from "../../utils/customLink";

import Image from "../../components/image";
import PropTypes from "prop-types";


const SchoolsCard = ({
  bgImage,
  schoolTitle,
  slug,
  subTitle,
  isRounded,
  isRoundedTop,
  location,
  tripDate,
  bgColor
}) => {
  return (
    <>
      <div className={`${bgColor ?? "bg-white dark:bg-black-dark"}`}>
        <Link className="" to={`/school-trip/${slug}`}>
          <div className="rounded-sm h-44">
            {bgImage && (
              <Image
                imageAlt={schoolTitle}
                image={""}
                sourceUrl={bgImage}
                imageClass={`object-cover object-center w-full h-44 ${
                  isRounded ? "rounded-t-sm" : ""
                } ${isRoundedTop ? "rounded-t-md" : ""}`}
              />
            )}
          </div>
          <div className="h-auto px-4 pt-3 bg-white dark:bg-black-dark rounded-b-md">
            {schoolTitle && (
              <>
                <div className="flex flex-row items-center justify-start gap-2">
                  <div
                    className="text-black-lighter dark:text-white text-xl font-body font-normal"
                    dangerouslySetInnerHTML={{ __html: schoolTitle }}
                  />
                </div>
              </>
            )}
            {subTitle && (
              <div
                className="text-black-lighter dark:text-white text-md font-body font-light"
                dangerouslySetInnerHTML={{
                  __html: subTitle
                }}
              />
            )}

            {location && (
              <div className="flex flex-col sm:flex-row sm:items-center justify-start sm:gap-5 py-3">
                <div className="flex gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="stroke-black-lighter dark:stroke-white w-4 h-4 mt-1"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                    />
                  </svg>
                  <div
                    className="text-mob text-black-lighter dark:text-gray-generic font-body"
                    dangerouslySetInnerHTML={{ __html: location }}
                  />
                </div>

                <div className="flex gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="stroke-black-lighter dark:stroke-white w-4 h-4 mt-1"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z"
                    />
                  </svg>
                  <div
                    className="text-mob text-black-lighter dark:text-gray-generic font-body"
                    dangerouslySetInnerHTML={{
                      __html: `${tripDate ? `Trip Date : ${tripDate}` : ""}`
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </Link>
      </div>
    </>
  );
};

SchoolsCard.defaultProps = {
  schoolTitle: "",
  location: "",
  tripDate: "",
  bgImage: "",
  iconImage: "",
  isRounded: false,
  isRoundedTop: false,
  captionColor: "",
  captionSize: "",
  bgColor: "",
  truncateDesc: true
};

SchoolsCard.propTypes = {
  bgImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  schoolTitle: PropTypes.string,
  location: PropTypes.string,
  tripDate: PropTypes.string,
  isRounded: PropTypes.bool,
  isRoundedTop: PropTypes.bool,
  truncateDesc: PropTypes.bool,
  captionColor: PropTypes.string,
  captionSize: PropTypes.string,
  bgColor: PropTypes.string
};

export default SchoolsCard;
